export default "__VITE_ASSET__DwEyr9mn__"